import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getLocalStorageData from '../utlis/storageUtils';
import { BASE_API_URL } from '../constants';
import { getHeaders } from '../utlis/security';

export const audioBookByAuthorPageApi = createApi({
  reducerPath: 'audioBookByAuthorPageApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: BASE_API_URL,
    prepareHeaders: async (headers) => {
      const customHeaders = await getHeaders('audioBookByAuthorPageApi');
      for (const [key, value] of Object.entries(customHeaders)) {
        headers.set(key, value);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchAudioBookByAuthorData: builder.query({
      query: ( option ) => ({
        url : 'https://snsapiv2.baganit.com/api/app/getauthorbyid',   // bookbyauthor
        method: 'POST',
        body : {
          "author_id": option, //publisher_id
          "phone": "",
          "platform": "miniapp",
          "udid": "190740e5f0032702",
          "user_id": getLocalStorageData(),
          "version_code": 29,
          "version_name": "1.2.9"
      },
      }), 
    })
  }),
});

export const { useFetchAudioBookByAuthorDataQuery, endpoints } = audioBookByAuthorPageApi;